// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"375":"c454f259","616":"8e3882c4","764":"b8626592","853":"b512ec81","992":"892ce2a3"}[chunkId] + ".chunk.css";
};